import { useEffect, useState } from "react";
import styles from "../styles/style.module.css";
import { LOCAL_CONSTANTS } from "../../../lib/constants";
import moment from "moment";
import { OrderTypes } from "../../../interfaces";
import { useNavigate, useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import UpsellForm from "../../../ui/modals/upsellForm";
import { manuallySentMail } from "../api";
import { toast } from "react-toastify";

const JOYTEL_USAGE_API =
  "https://api-cb.commbitz.com/esim/joytel-esim-usage-enquiry";

interface UserListProp {
  loading: boolean;
  orders: any;
  setRefreshData: any;
  refreshData: any;
}

interface UsageData {
  effectiveTime: string;
  expiryTime: string;
  totalUsage: number;
  totalUsageFormatted?: string;
  dailyUsage: Array<{ date: string; usage: string; region?: { country: string } }>;
  summary?: {
    totalDays: number;
    averageDailyUsage: string;
    highestUsageDay: string;
    lowestUsageDay: string;
  };
}

interface ProfileData {
  eid?: string;
  device?: string;
  clientIp?: string;
  pin1?: string;
  pin2?: string;
  puk1?: string;
  puk2?: string;
  imei?: string;
  mcc?: string;
  cfCode?: string;
  apnExplain?: string;
  state?: string;
  profileType?: string;
}

const OrderList = ({
  loading,
  orders,
  setRefreshData,
  refreshData,
}: UserListProp) => {
  const isFree = orders?.list[0]?.isFree;
  const [show, setShow] = useState<boolean>(false);
  const [orderId, setOrderId] = useState<string>("");
  const { partnerName, partnerWebsiteId } = useParams();

  const [showUsageModal, setShowUsageModal] = useState(false);
  const [usageCoupon, setUsageCoupon] = useState<string | null>(null);
  const [usageLoading, setUsageLoading] = useState(false);
  const [usageData, setUsageData] = useState<UsageData | null>(null);
  const [profileData, setProfileData] = useState<ProfileData | null>(null);
  const fetchUsageData = async (coupon: string) => {
    setUsageLoading(true);
    setUsageData(null);
    setProfileData(null);
    try {
      const res = await fetch(
        `${JOYTEL_USAGE_API}?coupon=${encodeURIComponent(coupon)}`
      );
      const json = await res.json();
      const inner = json?.data?.data;
      const profileInfo = json?.data?.profileInfo;
      if (inner) setUsageData(inner);
      if (profileInfo) {
        setProfileData({
          eid: profileInfo.eid ?? "",
          device: profileInfo.device ?? "",
          clientIp: profileInfo.clientIp ?? "",
          pin1: profileInfo.pin1 ?? "",
          pin2: profileInfo.pin2 ?? "",
          puk1: profileInfo.puk1 ?? "",
          puk2: profileInfo.puk2 ?? "",
          imei: profileInfo.imei ?? "",
          mcc: profileInfo.mcc ?? "",
          cfCode: profileInfo.cfCode ?? "",
          apnExplain: profileInfo.apnExplain ?? "",
          state: profileInfo.state,
          profileType: profileInfo.profileType,
        });
      }
    } catch {
      setUsageData(null);
      setProfileData(null);
    } finally {
      setUsageLoading(false);
    }
  };

  const openUsageModal = (coupon: string) => {
    setUsageCoupon(coupon);
    setShowUsageModal(true);
    fetchUsageData(coupon);
  };

  const closeUsageModal = () => {
    setShowUsageModal(false);
    setUsageCoupon(null);
    setUsageData(null);
    setProfileData(null);
  };

  const navigate = useNavigate();

  const roles = window.localStorage.getItem("admin_roles");
  const routAccess =
    (roles !== null && LOCAL_CONSTANTS.ROLES.NIYO_USER === Number(roles)) ||
    (roles !== null && LOCAL_CONSTANTS.ROLES.VFS_USER === Number(roles)) ||
    (roles !== null &&
      LOCAL_CONSTANTS.ROLES.BHASIN_TRAVEL_USER === Number(roles)) ||
    (roles !== null &&
      LOCAL_CONSTANTS.ROLES.AIR_INDIA_USER === Number(roles)) ||
    (roles !== null && LOCAL_CONSTANTS.ROLES.FLEXWAYS_USER === Number(roles)) ||
    (roles !== null && LOCAL_CONSTANTS.ROLES.ROAM === Number(roles)) ||
    (roles !== null && LOCAL_CONSTANTS.ROLES.HOSHI === Number(roles)) ||
    (roles !== null && LOCAL_CONSTANTS.ROLES.ASEGO === Number(roles)) ||
    
    (roles !== null && LOCAL_CONSTANTS.ROLES.AZGO === Number(roles));
  const hideTravellingDate =
    partnerName?.toLowerCase() === LOCAL_CONSTANTS.PARTNERS.BHASIN ||
    partnerName?.toLowerCase() === LOCAL_CONSTANTS.PARTNERS.AIRINDIA||
    partnerName?.toLowerCase() === LOCAL_CONSTANTS.PARTNERS.FLEXWAYS ||
    partnerName?.toLowerCase() === LOCAL_CONSTANTS.PARTNERS.ROAM ||
  partnerName?.toLowerCase() === LOCAL_CONSTANTS.PARTNERS.HOSHI ||
    partnerName?.toLowerCase() === LOCAL_CONSTANTS.PARTNERS.ASEGO ||
    partnerName?.toLowerCase() === LOCAL_CONSTANTS.PARTNERS.AZGO;
  const hidePhoneNumber =
    partnerName?.toLowerCase() === LOCAL_CONSTANTS.PARTNERS.NIYO;

  return (
    <>
      <div className={styles.total_count}>
        <label>Total Order</label>
        <span className={styles.order_count}>{orders?.count}</span>
      </div>
      <div className={styles.scrollTable}>
        <table>
          <thead>
            <tr>
              <th>#</th>
              {isFree && <th>Name</th>}
              <th>Email</th>
              {isFree && <th>Phone Number</th>}
              {!hidePhoneNumber && <th>Phone Number</th>}
              <th>{!isFree ? "Bundle Name" : "Travelling Country"}</th>
              <th>Order Date</th>
              <th>Order Placed</th>
              {/* <th>Travelling Date</th>
               */}
              {!hideTravellingDate && <th>Travelling Date</th>}

              {isFree && (
                <>
                  <th>QR sent</th>
                  {LOCAL_CONSTANTS.ROLES.COMMBITZ_USER === Number(roles) && (
                    <th>Manual mail</th>
                  )}
                </>
              )}
              {!isFree && (
                <>
                  <th>Payment Status</th>
                  <th>Currency</th>
                  <th>Price</th>
                  <th>Quantity</th>
                </>
              )}
              <th>URL</th>
                <th>Free order</th>
                <th>Iccid</th>
              {partnerName?.toLocaleLowerCase() !==
                LOCAL_CONSTANTS.PARTNERS.GLOBALTIX && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan={7} align="center" className={styles.loadingText}>
                  {LOCAL_CONSTANTS.loading}
                </td>
              </tr>
            )}
            {!loading && orders.list.length === 0 && (
              <tr>
                <td colSpan={7} align="center">
                  Order not found
                </td>
              </tr>
            )}
            {!loading &&
              orders.list.map((item: any, index: number) => (
                <tr key={item._id}>
                  <td>{index + 1}</td>
                  {isFree && (
                    <td>{`${item.user?.fullName || LOCAL_CONSTANTS.na}`}</td>
                  )}
                  <td>{`${item.user?.email}`}</td>
                  {isFree && (
                    <td>
                      {!item.user?.countryCode
                        ? LOCAL_CONSTANTS.na
                        : item.user?.countryCode + " " + item.user?.phoneNumber}
                    </td>
                  )}
                  {!hidePhoneNumber && (
                    <td>
                      {!item.user?.countryCode
                        ? LOCAL_CONSTANTS.na
                        : item.user?.countryCode + " " + item.user?.phoneNumber}
                    </td>
                  )}
                  <td>{item.bundle?.name}</td>
                  <td>
                    {moment(item?.createdAt).format(LOCAL_CONSTANTS.dateFormat)}
                  </td>
                  <td>
                    {
                      LOCAL_CONSTANTS.paymentOrderStatus?.find(
                        (elt: OrderTypes.StatusEnums) =>
                          elt.value === item.orderStatus
                      )?.label
                    }
                  </td>
                  {/* <td> {item.user?.travellingDate ? moment(item.user?.travellingDate).format(LOCAL_CONSTANTS.dateFormat) : LOCAL_CONSTANTS.na}</td> */}

                  {!hideTravellingDate && (
                    <td>
                      {item.user?.travellingDate
                        ? moment(item.user?.travellingDate).format(
                            LOCAL_CONSTANTS.dateFormat
                          )
                        : LOCAL_CONSTANTS.na}
                    </td>
                  )}

                  {isFree && (
                    <>
                      <td>
                        {" "}
                        {item?.freeEsimQrEmailSent || item?.orderStatus == 2
                          ? "Yes"
                          : "Pending"}
                      </td>
                      {LOCAL_CONSTANTS.ROLES.COMMBITZ_USER ===
                        Number(roles) && (
                        <td>
                          {" "}
                          {item?.freeEsimQrEmailSent ||
                          item?.orderStatus == 2 ? (
                            <button
                              disabled
                              className={styles.loyalityPointBtn}
                            >
                              {" "}
                              Success
                            </button>
                          ) : (
                            <button
                              className={styles.loyalityPointBtn}
                              onClick={() => {
                                toast.promise(
                                  manuallySentMail({ orderId: item._id }),
                                  {
                                    pending: {
                                      render() {
                                        return "Trying to send email...";
                                      },
                                    },
                                    success: {
                                      render({ data }) {
                                        setRefreshData(!refreshData);
                                        return "Email sent successfully.";
                                      },
                                    },
                                    error: {
                                      render({ data }) {
                                        return "Something went Wrong.";
                                      },
                                    },
                                  }
                                );
                              }}
                            >
                              {" "}
                              Pending
                            </button>
                          )}
                        </td>
                      )}
                    </>
                  )}
                  {!isFree && (
                    <>
                      <td>
                        {
                          LOCAL_CONSTANTS.paymentOrderStatus?.find(
                            (elt: OrderTypes.StatusEnums) =>
                              elt.value === item.paymentStatus
                          )?.label
                        }
                      </td>
                      <td>{item.priceCurrency}</td>
                      <td>{item?.price?.toFixed(2)}</td>
                      <td>{item.quantity}</td>
                      {/* {item?.documents &&  */}
                    </>
                  )}
                  <td>{item.url || "N/A"}</td>
                    <td>{item.isFree ? "Yes" : "No"}</td>
                    <td>{item.joytelsnCode ?? LOCAL_CONSTANTS.na}</td>
{partnerName?.toLocaleLowerCase() !==
                LOCAL_CONSTANTS.PARTNERS.GLOBALTIX && (
                    <td>
                        <button
                          className={styles.loyalityPointBtn}
                          onClick={() =>
                            openUsageModal(
                              item.joytelsnPin ?? item.joytelsnCode ?? ""
                            )
                          }
                        >
                          View Usage
                        </button>
                      <button
                        className={styles.loyalityPointBtn}
                        onClick={() => navigate(`/document/${item._id}`)}
                      >
                        View Documents
                      </button>
                      {/* {isFree && (
                        <>
                          {!routAccess && (
                            <button
                              className={styles.loyalityPointBtn}
                              onClick={() => {
                                setOrderId(item._id);
                                setShow(true);
                              }}
                            >
                              Upsell Form
                            </button>
                          )}
                          <button
                            className={styles.loyalityPointBtn}
                            onClick={() =>
                              navigate(
                                `/partners/${partnerName}/${partnerWebsiteId}/upsell-records?orderId=${item._id}`
                              )
                            }
                          >
                            Upsell Records
                          </button>
                        </>
                      )} */}
                    </td>
                  )}

                  {/* } */}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <UpsellForm show={show} setShow={setShow} orderId={orderId} />

        <Modal
          show={showUsageModal}
          onHide={closeUsageModal}
          size="xl"
          centered
          className={styles.usageModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Data Usage Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {usageLoading ? (
              <div className="text-center py-4">Loading...</div>
            ) : !usageCoupon ? (
              <div className="text-center py-4">No coupon available</div>
            ) : usageData ? (
              <div className={styles.usageContent}>
                <div className={styles.usageSummaryCard}>
                  <div className={styles.summaryItem}>
                    <h4>Total Usage</h4>
                    <p>{usageData.totalUsageFormatted ?? usageData.totalUsage}</p>
                  </div>
                  <div className={styles.summaryItem}>
                    <h4>Validity Period</h4>
                    <p>From: {usageData.effectiveTime}</p>
                    <p>To: {usageData.expiryTime}</p>
                  </div>
                </div>
                {usageData.dailyUsage?.length > 0 && (
                  <>
                    <div className={styles.usageStats}>
                      <h4>Usage Statistics</h4>
                      <div className={styles.statsGrid}>
                        <div className={styles.statItem}>
                          <span>Total Days</span>
                          <strong>{usageData.summary?.totalDays ?? 0}</strong>
                        </div>
                        <div className={styles.statItem}>
                          <span>Average Daily</span>
                          <strong>
                            {usageData.summary?.averageDailyUsage ?? "0 MB"}
                          </strong>
                        </div>
                        <div className={styles.statItem}>
                          <span>Highest Usage</span>
                          <strong>
                            {usageData.summary?.highestUsageDay ?? "0 MB"}
                          </strong>
                        </div>
                        <div className={styles.statItem}>
                          <span>Lowest Usage</span>
                          <strong>
                            {usageData.summary?.lowestUsageDay ?? "0 MB"}
                          </strong>
                        </div>
                      </div>
                    </div>

                    <div className={styles.dailyUsageSection}>
                      <h4>Daily Usage Breakdown</h4>
                      <div className={styles.usageTable}>
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Usage</th>
                              <th>Region</th>
                            </tr>
                          </thead>
                          <tbody>
                            {usageData.dailyUsage.map((usage, index) => (
                              <tr key={index}>
                                <td>{usage.date}</td>
                                <td>{usage.usage}</td>
                                <td>
                                  {usage.region?.country ?? LOCAL_CONSTANTS.na}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </>
                )}

                {profileData && (
                  <div className={`mt-5 ${styles.profileDataSection}`}>
                    <h4>Profile Information</h4>
                    <div className={styles.profileGrid}>
                      <div className={styles.profileItem}>
                        <div className={styles.profileLabel}>EID:</div>
                        <div className={styles.profileValue}>
                          {profileData.eid ?? ""}
                        </div>
                      </div>
                      <div className={styles.profileItem}>
                        <div className={styles.profileLabel}>Device:</div>
                        <div className={styles.profileValue}>
                          {profileData.device ?? ""}
                        </div>
                      </div>
                      <div className={styles.profileItem}>
                        <div className={styles.profileLabel}>Client IP:</div>
                        <div className={styles.profileValue}>
                          {profileData.clientIp ?? ""}
                        </div>
                      </div>
                      <div className={styles.profileItem}>
                        <div className={styles.profileLabel}>PIN1:</div>
                        <div className={styles.profileValue}>
                          {profileData.pin1 ?? ""}
                        </div>
                      </div>
                      <div className={styles.profileItem}>
                        <div className={styles.profileLabel}>PIN2:</div>
                        <div className={styles.profileValue}>
                          {profileData.pin2 ?? ""}
                        </div>
                      </div>
                      <div className={styles.profileItem}>
                        <div className={styles.profileLabel}>PUK1:</div>
                        <div className={styles.profileValue}>
                          {profileData.puk1 ?? ""}
                        </div>
                      </div>
                      <div className={styles.profileItem}>
                        <div className={styles.profileLabel}>PUK2:</div>
                        <div className={styles.profileValue}>
                          {profileData.puk2 ?? ""}
                        </div>
                      </div>
                      <div className={styles.profileItem}>
                        <div className={styles.profileLabel}>IMEI:</div>
                        <div className={styles.profileValue}>
                          {profileData.imei ?? ""}
                        </div>
                      </div>
                      <div className={styles.profileItem}>
                        <div className={styles.profileLabel}>MCC:</div>
                        <div className={styles.profileValue}>
                          {profileData.mcc ?? ""}
                        </div>
                      </div>
                      <div className={styles.profileItem}>
                        <div className={styles.profileLabel}>CF Code:</div>
                        <div className={styles.profileValue}>
                          {profileData.cfCode || "N/A"}
                        </div>
                      </div>
                      <div className={styles.profileItem}>
                        <div className={styles.profileLabel}>APN:</div>
                        <div className={styles.profileValue}>
                          {profileData.apnExplain ?? ""}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="text-center py-4">
                No usage data available
              </div>
            )}
          </Modal.Body>
        </Modal>
    </>
  );
};

export default OrderList;
